function ensureShippingMessage() {
  let messageElement = document.getElementById("shipping-message");

  if (!messageElement) {
    console.log('Shipping message element not found, creating it...');
    
    // Find the variant selector
    const variantSelector = document.querySelector('.product-form__input--swatch');
    if (variantSelector) {

      const shippingContainer = document.createElement('div');
      shippingContainer.className = 'shipping-message';
      shippingContainer.style.marginTop = '15px';
      shippingContainer.style.padding = '10px';
      shippingContainer.style.background = '#f9f9f9';
      shippingContainer.style.borderRadius = '4px';
      
      const icon = document.querySelector('.shipping-message [class*="icon"]')?.cloneNode(true);
      if (icon) {
        shippingContainer.appendChild(icon);
      }
      
      messageElement = document.createElement('span');
      messageElement.id = 'shipping-message';
      shippingContainer.appendChild(messageElement);
      
      variantSelector.appendChild(shippingContainer);
      console.log('Created new shipping message element');
    }
  }
  
  return messageElement;
}

function updateShippingMessage() {
  const storeTimeZone = "Europe/Amsterdam";  
  const now = new Date();
  const storeTime = new Date(now.toLocaleString("en-US", { timeZone: storeTimeZone }));
  const hour = storeTime.getHours();

  const messageElement = ensureShippingMessage();
  
  if (messageElement) {
    if (hour >= 16) {
      messageElement.textContent = "Order before 16:00 and we will ship it out same day.";
    } else {
      messageElement.textContent = "Shipped today if you buy in the next 2h.";
    }
    //console.log('Shipping message updated');
  }
}


document.addEventListener("DOMContentLoaded", function() {
  setInterval(updateShippingMessage, 1000);
});